import { Skeleton } from "@mui/material";
import { useUIStore } from "@store/ui.store";
import { LayoutContainer, HeaderSlot, ContentScroll } from "./ContactsLayout";
import { withMainLayout } from "@shared/layouts/withMainLayout";

function ContactsLayoutSkeletonContent() {
  const isSidebarOpenDesktop = useUIStore(
    (state) => state.isSidebarOpenDesktop,
  );

  return (
    <LayoutContainer>
      <HeaderSlot $isSidebarOpenDesktop={isSidebarOpenDesktop}>
        <Skeleton variant="rectangular" height="100%" />
      </HeaderSlot>
      <ContentScroll $isSidebarOpenDesktop={isSidebarOpenDesktop}>
        <Skeleton variant="rounded" height={600} sx={{ margin: 2 }} />
      </ContentScroll>
    </LayoutContainer>
  );
}

export const ContactsLayoutSkeleton = withMainLayout(
  ContactsLayoutSkeletonContent,
);
